module.exports = __webpack_public_path__ + "static/img/homeNavigation5.3076c5c7.png";